export default "/images/bookmark.svg?4b8439822949fc7b58ef454d9500b3a4";